import Vue from "vue";
// import store from "../store";
// 自动加载并注册全局组件
const componentsContext = require.context("./", true, /index\.vue$/);
componentsContext.keys().forEach((component) => {
  const componentConfig = componentsContext(component).default;
  // const componentName = component
  //   .split("/")
  //   .pop()
  //   .replace(/\.\w+$/, ""); // 提取组件名
  if (componentConfig && componentConfig.name) {
    const componentName = componentConfig.name;
    console.log("组件名称", componentName, componentConfig);
    Vue.component(componentName, componentConfig);
  }
});
// console.log(store.state.commonStore,'this.$store');
// const accountId = store.state.commonStore.accountId
Vue.prototype.getComponentNameByType = function (key) {
  const object = {
    "-1": "ActivityHeader",//头部
    "-2":'Calendar',//日历组件
    0: "CreaterSays",
    1: "UrgentRecruitmentCompany",//职位(双列)
    2: "CompanyAndJobList",//公司职位
    3: "JobListSingleSide",//职位(单列)
    4: "QuestionsAndAnswers",
    5: "VoteMod",
    6: "ActivityImage",//图片组件
    7: "EnterpriseScrollview",
    8: "AiFloatingAction",
    9: "ActivityImages",//图片热区组件
    11: "Tasks",//激励组件
    13: "SignInComponent",
    14:"ActivityWheel",//大转盘
    15: "GoodsBlock",//好职组件
    17:"DoubleColumnLabel",//职位列表(双列+标签页)
    21: "MulticolumnJobList",//职位列表（多列+滑动）
    22: 'CustomizedMulticolumnJobList', // 自定义的职位列表（最新动态组件），该组件没有在BCOP后台配置
  };
  return object[key];
};
